import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TiersComponent } from './tiers.component';
import { TierDetailComponent } from './tier-detail/tier-detail.component';
import { TierResolver } from './resolvers/tier.resolver';
import { TiersResolver } from './resolvers/tiers.resolver';

const routes: Routes = [
	{
		path: '', data: {breadcrumb: 'Staffels'},
		children: [
			{path: 'aanmaken', data: {title: 'Staffel Aanmaken', breadcrumb: 'Aanmaken'}, component: TierDetailComponent},
			{
				path: ':id',
				data: {title: 'Staffel Bewerken', breadcrumb: 'Bewerken'},
				component: TierDetailComponent,
				resolve: {tier: TierResolver}
			},
			{path: '', data: {title: 'Staffels'}, component: TiersComponent, resolve: {tiers: TiersResolver}},
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [TierResolver, TiersResolver]
})
export class TiersRoutingModule
{
}



// WEBPACK FOOTER //
// ./src/app/tiers/tiers-routing.module.ts